import DraftEmailContent from "../../../../../lib/html5-software-library/src/ranj/eng/content/DraftEmailContent";
import AbstractCommand from "../../../core/application/AbstractCommand";
import KeyDecisionContentEvent from "../event/KeyDecisionContentEvent";
import KeyDecisionsConfig from "../model/KeyDecisionsConfig";
import KeyDecisionsModel from "../model/KeyDecisionsModel";
import KeyDecisionAnswer from "../model/KeyDecisionAnswer";
import MCBlock from "../../../../../lib/html5-software-library/src/ranj/eng/content/MCBlock";
import NGTVariableManager from "../../../ngt/base/NGTVariableManager";
import DialogContentComponent from "../../../../../lib/html5-software-library/src/ranj/eng/content/DialogContentComponent";
import StoryVariables from "../../util/StoryVariables";
import VariableMutation from "../../../../../lib/html5-software-library/src/ranj/eng/content/VariableMutation";
import SaveGameEvent from "../../../app/save-game/events/SaveGameEvent";
import ProgressGameModel from "../../save-game/model/ProgressGameModel";
import TrackString from "../../../analytics/TrackString";

export default class KeyDecisionContentCompletedCommand extends AbstractCommand {
    /**
     * @constructor
     * @param {soma.EventDispatcher} dispatcher 
     * @param {KeyDecisionsModel} keyDecisionsModel 
     * @param {KeyDecisionsConfig} keyDecisionsConfig 
     * @param {NGTVariableManager} variableManager 
     * @param {*} scoreConfig 
     * @param {ProgressGameModel} progressGameModel 
     */
    constructor(dispatcher, keyDecisionsModel, keyDecisionsConfig, variableManager, scoreConfig, progressGameModel) {
        super(dispatcher);

        this._keyDecisionsModel = keyDecisionsModel;
        this._keyDecisionsConfig = keyDecisionsConfig;
        this._variableManager = variableManager;
        this._scoreConfig = scoreConfig;
        this._progressGameModel = progressGameModel;
    }

    execute(evt) {
        /** @type {KeyDecisionContentEvent} */
        const data = evt.params.data;
        const keyDecisionContent = data.content;
        console.log(`[KeyDecisionContentCompletedCommand] Key decision with content id '${keyDecisionContent.getContentID()}' becomes completed.`);
        let keyDecision = this._keyDecisionsModel.getAvailableKeyDecisionByContent(keyDecisionContent);
        if (!keyDecision) {
            // If this happens in chapter 3 in key decision 3_3, 3_4 or 3_5, this may cause issues later for determining the epilogue.
            console.error(`[KeyDecisionContentCompletedCommand] No keydecision available for content '${keyDecisionContent.getContentID()}'!`);
            this.trackEvent(TrackString.EVENT_KEYDECISION_UNAVAILABLE, { content_id: keyDecisionContent.getContentID() })
            // For now, we just log an error, and keep everything the same, so un unhandled exception will occur in the call below:
        }
        keyDecision = this._processKeyDecision(keyDecisionContent, keyDecision);
        this._generateStoryVariablesFromPlayerAnswers(keyDecision);
        this._generatePathFromScore();
        this._keyDecisionsModel.completeKeyDecision(keyDecision);

        //Disabled saving for now, because it's not robust yet.
        // this.dispatch(SaveGameEvent.SAVE_GAME);
    }

    _generatePathFromScore() {
        let score = this._variableManager.getVariable(StoryVariables.SCORE);
        let path = this._scoreConfig.getUnlockedPath(this._progressGameModel.chapter, this._progressGameModel.week, score);
        console.log(`[KeyDecisionContentCompletedCommand] Generate PATH '${path}' from SCORE '${score}'`);
        this._progressGameModel.addPath(path);
        console.log(`[KeyDecisionContentCompletedCommand] Current Player PATH '${this._progressGameModel.path}'`);
    }

    _generateStoryVariablesFromPlayerAnswers(keyDecision) {
        for (let playerAnswer of keyDecision.playerAnswers) {
            let id = playerAnswer.id;
            if (id != null && id != "") {
                this._variableManager.setVariable(id, true);
                console.log(`[KeyDecisionContentCompletedCommand] Generate Answer Variable with id '${id}'`);
                // Generate Score
                let scoreNode = this._scoreConfig.getScore(id);
                if (scoreNode != null) {
                    console.log(`[KeyDecisionContentCompletedCommand] Add Score '${scoreNode.score}'for answer with id '${id}'`);
                    this._variableManager.setVariable(StoryVariables.SCORE, scoreNode.score, VariableMutation.ADD);
                } else {
                    console.log(`[KeyDecisionContentCompletedCommand] No score found for answer with id '${id}'`);
                }
            } else {
                console.log(`[KeyDecisionContentCompletedCommand] Missing Answer id for '${playerAnswer.answer}'`);
            }
        }
    }

    _processKeyDecision(content, keyDecision) {
        // For Email Key Decision
        if (content instanceof DraftEmailContent) {
            var optimalAnswers = [];
            var playerAnswers = [];
            var contentBlocks = content.getContentBlocks().filter(cb => cb instanceof MCBlock);
            for (let contentBock of contentBlocks) {
                let selectedContentBlockIndex = contentBock.getSelectedOptionIndex();
                let optionsContentBlock = contentBock.getOptions();
                for (let i = 0; i < optionsContentBlock.length; i++) {
                    let optionContentBlock = optionsContentBlock[i];
                    let id = optionContentBlock.getDescription().getContentID();
                    let answer = optionContentBlock.getDescription().getText();
                    let rating = optionContentBlock.getDescription().getBalloonType();
                    let feedback = optionContentBlock.getValue().getText();
                    if (rating == KeyDecisionAnswer.GOOD_RATING) {
                        optimalAnswers.push(new KeyDecisionAnswer(id, answer, feedback, rating, false));
                    }
                    if (i == selectedContentBlockIndex) {
                        playerAnswers.push(new KeyDecisionAnswer(id, answer, feedback, rating, false));
                    }
                }
            }
            keyDecision.optimalAnswers = optimalAnswers;
            keyDecision.playerAnswers = playerAnswers;

        }
        else {
            // For Plan Composer Key Decision & Dialogue Key Decision
            if (content.optimalAnswers !== undefined) {
                keyDecision.optimalAnswers = content.optimalAnswers;
            }
            if (content.playerAnswers !== undefined) {
                keyDecision.playerAnswers = content.playerAnswers;
            }
        }
        return keyDecision;
    }
}